import { deliveryMenus } from "./menus";
import { importMenu } from "./import-menu";
import { deliverySettings } from "./settings";
import { deliveryReport } from "./report";
import { syncMenu } from "./sync-menu";

export const delivery = {
	goBack: "Voltar",
	updateManyExternalIntegrations: {
		success: "Integrações atualizadas com sucesso",
	},
	externalStoreIntegrationStatus: {
		synced: "Sincronizado",
		pendingSyncing: "Sincronização pendente",
		pendingImporting: "Importação pendente",
	},
	ordersManager: {
		title: "Gestor de pedidos",
		description:
			"Acompanhe e gerencie os pedidos que chegam do Entregue já, Comanda Online e Pedido na mesa.",
		tabs: {
			newOrders: "Novos Pedidos",
			inDelivery: "Em entrega",
			completed: "Concluídos",
		},
		createOrder: "Criar novo pedido",
		filter: {
			placeholder: "Filtrar por",
			orderStatus: "Status do Pedido",
			paymentMethod: "Forma de Pagamento",
			orderOrigin: "Origem do Pedido",
			appliedFilters: "filtro(s) aplicado(s)",
		},
		loading: "Carregando",
		total: "Total: {{value}}",
		new: "Novo",
		emptyState: {
			title: "Ainda não temos pedidos {{status}}.",
			description: "Mostraremos aqui quando você receber novos pedidos.",
		},
		immersion: {
			enter: "Imersão",
			exit: "Sair da imersão",
		},
		sound: {
			on: "Som ligado",
			off: "Som mudo",
		},
		whatsNew: {
			intro: {
				title: "Temos novidades por aqui! 🎉",
				description:
					"Atualizamos o Gestor de pedidos. Bora ver rapidinho o que mudou?",
				start: "Ver novidades",
			},
			step: "Passo {{current}} de {{total}}",
			next: "Próximo",
			finish: "Entendi",
			skip: "Pular",
			test: "Tocar som de exemplo",
			immersion: {
				title: "Novo: Modo Imersão",
				description:
					"Deixe o gestor em tela cheia, sem menus, ideal para usar no balcão.",
			},
			sound: {
				title: "Novo: Som de pedido novo",
				description:
					"Tocamos um alerta sonoro quando chega um pedido novo. Use o botão para ligar ou silenciar.",
			},
		},
	},
	orderStatuses: {
		placed: "Pendentes",
		confirmed: "Aceitos",
		ready: "Prontos",
		dispatched: "Em entrega",
		concluded: "Concluídos",
		cancelled: "Cancelados",
	},
	deliveryStatus: {
		availableForPickup: "Disponível para retirada",
		availableForDelivery: "Disponível para entrega",
	},
	deliverySettings,
	deliveryReport,
	deliveryMenus,
	syncMenu,
	importMenu,
};
